<template>
  <div class="pageContainer">
    <BannerComponent>
      <h6 class="banner-heading">Contact Information</h6>
    </BannerComponent>

    <div class="card cardBackground">
      <div class="cardLine">
        <p>Phone Support:</p>
        <a href="tel:+8015001607" class="phone-link">(801) 500-1607</a>
      </div>
      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Email Support:</p>
        <a href="mailto:help@kovohome.com" class="email-link">help@kovohome.com</a>
      </div>
<!--      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Live Chat:</p>
        <p>Available 24/7 on our website</p>
      </div>-->
    </div>

<!--    <BannerComponent>
      <button
          class="banner-toggle-btn"
          @click="toggleSupportHours"
          :aria-expanded="supportHoursOpen"
      >
        <font-awesome-icon
            :icon="['fas', supportHoursOpen ? 'chevron-down' : 'chevron-right']"
        />
      </button>
      <h6 class="banner-heading">Support Hours</h6>
    </BannerComponent>

    <div class="card cardBackground" v-if="supportHoursOpen">
      <div class="cardLine">
        <p>Monday - Friday:</p>
        <p>8:00 AM - 6:00 PM PST</p>
      </div>
      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Saturday:</p>
        <p>9:00 AM - 3:00 PM PST</p>
      </div>
      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Sunday:</p>
        <p>Closed</p>
      </div>
      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Emergency Support:</p>
        <p>24/7 for critical issues</p>
      </div>
    </div>

    <BannerComponent>
      <button
          class="banner-toggle-btn"
          @click="toggleQuickActions"
          :aria-expanded="quickActionsOpen"
      >
        <font-awesome-icon
            :icon="['fas', quickActionsOpen ? 'chevron-down' : 'chevron-right']"
        />
      </button>
      <h6 class="banner-heading">Quick Actions</h6>
    </BannerComponent>

    <div class="card cardBackground" v-if="quickActionsOpen">
      <div class="cardLine">
        <p>Call Support:</p>
        <button class="primaryButton" @click="callSupport">
          <font-awesome-icon :icon="['fas', 'phone']" />
          Call Now
        </button>
      </div>
      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Email Support:</p>
        <button class="secondaryButton" @click="emailSupport">
          <font-awesome-icon :icon="['fas', 'envelope']" />
          Send Email
        </button>
      </div>
      <div class="lineDiv"></div>
      <div class="cardLine">
        <p>Download Remote Support:</p>
        <button class="secondaryButton" @click="downloadRemoteSupport">
          <font-awesome-icon :icon="['fas', 'download']" />
          Download
        </button>
      </div>
    </div>-->
    
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
    <LoadingPage :is-visible="loading"/>
  </div>
</template>

<script>
import MessageModal from "@/components/MessageModal.vue";
import LoadingPage from "@/components/LoadingPage.vue";
import BannerComponent from "@/components/BannerComponent.vue";
import {useLoginStore} from "@/stores/loginStore";

export default {
  name: 'TechSupportPage',
  components: {
    LoadingPage, 
    MessageModal,
    BannerComponent
  },
  data(){
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
      loading: false,
      supportHoursOpen: false,
      quickActionsOpen: false,
    }
  },
  async mounted(){
    //console.clear()
    // TechSupportPage should be accessible to all users
    // Only show device status for users with device subscription
    if (useLoginStore().getSubscriptionType === 'device') {
      if (useLoginStore().getDeviceOnline) {
        console.log("Device online")
      } else {
        this.appMessage.text = "Device Offline"
        this.appMessage.type = 'info'
        this.$refs.messageModal.open()
      }
    }
    // Page is accessible to all users, device status only shown for device users
  },
  methods: {
    showError(e){
      this.appMessage.text = 'Error: ' + e
      this.appMessage.type = 'error'
      this.$refs.messageModal.open()
    },
    toggleSupportHours() {
      this.supportHoursOpen = !this.supportHoursOpen;
    },
    toggleQuickActions() {
      this.quickActionsOpen = !this.quickActionsOpen;
    },
    callSupport() {
      window.location.href = 'tel:+18005551234';
    },
    emailSupport() {
      window.location.href = 'mailto:support@guardian.com?subject=Support Request';
    },
    downloadRemoteSupport() {
      this.appMessage.text = "Remote support download will be available soon";
      this.appMessage.type = 'info';
      this.$refs.messageModal.open();
    },
  },
}
</script>

<style scoped>
.banner-toggle-btn {
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 1rem;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: transform 0.2s ease;
}

.banner-toggle-btn:hover {
  transform: scale(1.1);
}

.banner-heading {
  color: var(--text-primary);
  margin: 0;
  font-size: 1.1rem;
}

.phone-link {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: bold;
  transition: color 0.2s ease;
}

.phone-link:hover {
  color: var(--color-secondary);
  text-decoration: underline;
}

.email-link {
  color: var(--color-primary);
  text-decoration: none;
  transition: color 0.2s ease;
}

.email-link:hover {
  color: var(--color-secondary);
  text-decoration: underline;
}

.primaryButton, .secondaryButton {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.primaryButton {
  background-color: var(--color-primary);
  color: white;
}

.primaryButton:hover {
  background-color: var(--color-secondary);
}

.secondaryButton {
  background-color: var(--color-secondary-button);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.secondaryButton:hover {
  background-color: var(--color-primary);
  color: white;
}
</style>